"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHoliday = void 0;
const date_fns_1 = require("date-fns");
const isHoliday = (date, nationalHolidays) => {
    return nationalHolidays.some((holiday) => {
        // HACK:
        // holidays.period.startがUTCで入ってくるので補正する
        // そもそも今ここに日本の祝日しか入ってないからいけるけど...
        // また整理する必要あり
        return (0, date_fns_1.isSameDay)((0, date_fns_1.addHours)(holiday.period.start, 9), date);
    });
};
exports.isHoliday = isHoliday;
//# sourceMappingURL=isHoliday.js.map